import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArts } from "../../../actions/arts";
import { getProviders } from "../../../actions/providers";
import {
  getPendingUser,
  getUserRoles,
  registerPendingUser,
  userReject
} from "../../../actions/users";
import ConfirmDeleteDialog from "../../commons/dialog/confirmDeleteDialog";
import EditUserDialog from "../../commons/dialog/editUserDialog";
import UsersTable from "../../commons/table/usersTable";

const initialUser = {
  nombre: "",
  apellido: "",
  email: "",
  idRol: "",
  idArt: "",
  idPrestador: "",
  referenteGestor: null,
};

const PendingUsersContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const users = useSelector((state) => state.users.pendingUsersList);
  const loading = useSelector((state) => state.users.pendingUsersList.isFetching);
  const loadingArts = useSelector((state) => state.arts.isFetching);
  const loadingProviders = useSelector((state) => state.providers.listProviders.isFetching);
  const registerPendingUserState = useSelector((state => state.users.registerPendingUser));
  const userRejectState = useSelector((state => state.users.userReject));

  const [openEdit, setOpenEdit] = useState(false);
  const [user, setUser] = useState(initialUser);
  const [addingNewUser, setAddingNewUser] = useState(true);
  const [openDelete, setOpenDelete] = useState(false);

  useEffect(() => {
    dispatch(getPendingUser());
  }, []);

  const handleCloseEdit = () => {
    setUser(initialUser);
    setAddingNewUser(true);
    setOpenEdit(false);
  };

  const handleSubmitUser = (user, isNew) => {
    if (isNew) {
      // Esta tabla no cuenta con agregar nuevos usuarios.
    } else {
      dispatch(registerPendingUser(user))
        .then(() => {
          dispatch(getPendingUser());
          enqueueSnackbar(<p>Se ha creado el usuario correctamente!</p>, {
            variant: "success",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
          handleCloseEdit();
        })
    }
  };

  const handleDelete = () => {
    dispatch(userReject(user))
      .then(() => {
        dispatch(getPendingUser());
        enqueueSnackbar(<p>Se ha eliminado la adhesión correctamente!</p>, {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
        handleCloseDelete();
      })
  };

  const handleConfirmUser = (user) => {
    user.idPrestador = user.prestadores?.[0]?.id ?? null;
    dispatch(registerPendingUser(user)).then(() => {
      dispatch(getPendingUser());
      enqueueSnackbar(<p>Se ha confirmado el usuario correctamente!</p>, {
        variant: "success",
      });
    });
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setUser(initialUser);
  };

  const handleOpenDelete = (user) => {
    setUser(user);
    setOpenDelete(true);
  };
  const handleOpenEdit = (user) => {
    setUser({
      ...initialUser,
      ...user,
      idPrestador: user.prestadores?.[0]?.id ?? initialUser.idPrestador,
      arts: user.idArt ? user.idArt : null,
    });
    Promise.all([
      dispatch(getArts()),
      dispatch(getProviders()),
      dispatch(getUserRoles()),
    ]).finally(() => {
      setAddingNewUser(false);
      setOpenEdit(true);
    });
  };

  return (
    <div>
      <UsersTable
        data={users.data}
        loading={loading}
        title="Usuarios"
        fetchData={() => dispatch(getPendingUser())}
        handleOpenDelete={handleOpenDelete}
        handleConfirmUser={handleConfirmUser}
        handleOpenEdit={handleOpenEdit}
      />

      <EditUserDialog
        user={user}
        open={openEdit}
        handleClose={handleCloseEdit}
        addingNewUser={addingNewUser}
        handleSubmit={handleSubmitUser}
        loading={registerPendingUserState.isFetching || loadingArts || loadingProviders}
      />

      <ConfirmDeleteDialog
        loading={userRejectState.isFetching}
        open={openDelete}
        handleClose={handleCloseDelete}
        handleConfirm={handleDelete}
        title="Eliminar Adhesión"
        text={`¿Está seguro que desea eliminar la adhesión?`}
      />
    </div>
  );
};

export default PendingUsersContainer;
